interface PageTypes {
  BROADCAST: string;
  REGULAR: string;
  GROUP: string;
}

export const PAGE_TYPES: PageTypes = {
  BROADCAST: "broadcast",
  REGULAR: "regular",
  GROUP: "group",
};
